// assets/collection-filters.js
(function () {
  'use strict';

  // ── Estado de filtros ──
  var state = {
    condition: 'all',
    series:    [],
    marcas:    [],   // R8 — solo aplica a carcasas
    modelos:   [],
    priceMin:  0,
    priceMax:  9999999,
    sort:      'title-desc',
    view:      'grid',
  };

  // ── Elementos ──
  var grid         = document.getElementById('products-grid');
  var noResults    = document.getElementById('no-results');
  var resultsCount = document.getElementById('results-count');
  var mobileCount  = document.getElementById('mobile-count');
  var bsCount      = document.getElementById('bs-count');
  var activeFiltersWrap  = document.getElementById('active-filters');
  var activeFiltersInner = document.getElementById('active-filters-inner');
  var clearBtn     = document.getElementById('sf-clear-btn');
  var nrClearBtn   = document.getElementById('no-results-clear');

  if (!grid) return;

  // ── Tipos que sí manejan condición (ej. Accesorios: airpods,homepod) ──
  // Vacío en colecciones que no mandan este dato (ej. iPhone) — el
  // grupo Condición nunca se oculta ahí.
  var conditionTypesRaw = '';
  var collectionConfigEl = document.getElementById('collection-config');
  if (collectionConfigEl) conditionTypesRaw = collectionConfigEl.dataset.conditionTypes || '';
  var conditionTypes = conditionTypesRaw ? conditionTypesRaw.split(',') : [];

  // ── Todas las tarjetas ──
  // Un solo nodo por producto (sprint de performance, Fix 4) — antes
  // existía también un .product-list-row oculto por producto, duplicando
  // el DOM (34 productos = 68 nodos) y este mismo filtrado se corría dos
  // veces por card. La vista lista hoy es el mismo .product-card
  // reflowed por CSS (.col-grid.is-list, ver elephone.css), así que la
  // visibilidad ya no depende de state.view — solo del filtro.
  function getCards() {
    return Array.from(grid.querySelectorAll('.product-card'));
  }

  // ── Aplicar filtros ──
  function applyFilters() {
    var cards = getCards();
    var visible = 0;

    cards.forEach(function (card) {
      var cond   = card.dataset.condition || '';
      var serie  = card.dataset.serie     || '';
      var marca  = card.dataset.marca     || '';
      var modelo = card.dataset.modelo    || '';
      var price = parseInt(card.dataset.price) || 0;

      var condOk  = state.condition === 'all' || cond === state.condition;
      var serieOk = state.series.length === 0 || state.series.indexOf(serie) !== -1;
      var priceOk = price >= state.priceMin && price <= state.priceMax;
      // Precio 0 = consultar — siempre mostrar
      if (price === 0) priceOk = true;
      // R8 — marca y modelo: una tarjeta sin el dato (cable, HomePod) no pasa
      // el filtro cuando hay marca o modelo elegido. Es lo correcto: quien
      // filtra "ZAGG" no quiere ver un cargador.
      var marcaOk  = state.marcas.length === 0 || state.marcas.indexOf(marca) !== -1;
      var modeloOk = state.modelos.length === 0 || state.modelos.indexOf(modelo) !== -1;

      var show = condOk && serieOk && priceOk && marcaOk && modeloOk;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    // Actualizar contadores
    if (resultsCount) resultsCount.textContent = visible;
    if (mobileCount)  mobileCount.textContent  = visible;
    if (bsCount)      bsCount.textContent       = visible;

    // Sin resultados
    if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';

    // Botón limpiar
    var hasFilters = state.condition !== 'all' || state.series.length > 0 || state.priceMin > 0 || state.priceMax < 9999999;
    if (clearBtn) clearBtn.style.display = hasFilters ? 'block' : 'none';

    // Filtros activos pills
    renderActiveFilters();
    updateFilterBadge();

    // R6 — soltar el pre-filtro en linea: ya mandamos nosotros. Si se dejara
    // puesto, el usuario no podria quitar el filtro que trajo la URL.
    var pre = document.getElementById('prefiltro-tipo');
    if (pre) pre.remove();
  }

  // ── Ordenar ──
  function applySort() {
    var cards = getCards();
    cards.sort(function (a, b) {
      var pa = parseInt(a.dataset.price) || 0;
      var pb = parseInt(b.dataset.price) || 0;
      var na = a.querySelector('.pc-name') ? a.querySelector('.pc-name').textContent : '';
      var nb = b.querySelector('.pc-name') ? b.querySelector('.pc-name').textContent : '';
      if (state.sort === 'price-asc')  return pa - pb;
      if (state.sort === 'price-desc') return pb - pa;
      if (state.sort === 'title-asc')  return na.localeCompare(nb);
      if (state.sort === 'title-desc') return nb.localeCompare(na);
      return 0;
    });

    cards.forEach(function (card) { grid.appendChild(card); });

    applyFilters();
  }

  // ── Filtros activos ──
  function renderActiveFilters() {
    if (!activeFiltersInner) return;
    activeFiltersInner.innerHTML = '';
    var hasAny = false;

    if (state.condition !== 'all') {
      addActivePill(state.condition, function () {
        state.condition = 'all';
        syncSidebarCondition();
        syncBsCondition();
        applyFilters();
      });
      hasAny = true;
    }

    state.series.forEach(function (s) {
      var label = s.replace('serie-', 'iPhone ').replace('11-12', '11 y 12').replace('iphone-', 'iPhone ');
      addActivePill(label, function () {
        state.series = state.series.filter(function (x) { return x !== s; });
        syncSidebarSerie();
        syncBsSerie();
        applyFilters();
      });
      hasAny = true;
    });

    // R8
    state.marcas.forEach(function (m) {
      var btn = document.querySelector('.sf-marca-option[data-value="' + m + '"]');
      addActivePill(btn ? btn.textContent.trim() : m, function () {
        state.marcas = state.marcas.filter(function (x) { return x !== m; });
        syncSidebarMarcaModelo();
        syncBsMarcaModelo();
        applyFilters();
      });
      hasAny = true;
    });

    state.modelos.forEach(function (s) {
      var btn = document.querySelector('.sf-modelo-option[data-value="' + s + '"]');
      addActivePill(btn ? btn.textContent.trim() : s, function () {
        state.modelos = state.modelos.filter(function (x) { return x !== s; });
        syncSidebarMarcaModelo();
        syncBsMarcaModelo();
        applyFilters();
      });
      hasAny = true;
    });

    if (state.priceMax < 9999999 || state.priceMin > 0) {
      var priceLabel = state.priceMin === 0
        ? 'Hasta $' + (state.priceMax / 1000).toFixed(0) + 'k'
        : '$' + (state.priceMin / 1000).toFixed(0) + 'k – $' + (state.priceMax === 9999999 ? '+1M' : (state.priceMax / 1000).toFixed(0) + 'k');
      addActivePill(priceLabel, function () {
        state.priceMin = 0; state.priceMax = 9999999;
        syncSidebarPrice();
        syncBsPrice();
        applyFilters();
      });
      hasAny = true;
    }

    if (activeFiltersWrap) activeFiltersWrap.style.display = hasAny ? 'block' : 'none';
  }

  function addActivePill(label, onRemove) {
    var pill = document.createElement('span');
    pill.className = 'active-filter-pill';
    pill.innerHTML = label + ' <button class="active-filter-remove" aria-label="Quitar filtro">✕</button>';
    pill.querySelector('button').addEventListener('click', onRemove);
    activeFiltersInner.appendChild(pill);
  }

  function updateFilterBadge() {
    var badge = document.getElementById('filter-badge');
    var btn   = document.getElementById('mobile-filter-btn');
    var count = (state.condition !== 'all' ? 1 : 0)
              + state.series.length
              + state.marcas.length + state.modelos.length
              + (state.priceMax < 9999999 || state.priceMin > 0 ? 1 : 0);
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    if (btn) btn.classList.toggle('has-filters', count > 0);
  }

  // ── SIDEBAR — Condición ──
  document.querySelectorAll('.sf-cond-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.condition = opt.dataset.value;
      syncSidebarCondition();
      syncBsCondition();
      applyFilters();
    });
  });

  function syncSidebarCondition() {
    document.querySelectorAll('.sf-cond-option').forEach(function (o) {
      o.classList.toggle('is-active', o.dataset.value === state.condition);
      var radio = o.querySelector('.sf-radio');
      if (radio) radio.dataset.active = o.dataset.value === state.condition ? 'true' : 'false';
    });
  }

  // ── SIDEBAR — Serie ──
  document.querySelectorAll('.sf-serie-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var val = opt.dataset.value;
      var idx = state.series.indexOf(val);
      if (idx === -1) state.series.push(val);
      else state.series.splice(idx, 1);
      syncSidebarSerie();
      syncBsSerie();
      applyFilters();
    });
  });

  function syncSidebarSerie() {
    document.querySelectorAll('.sf-serie-option').forEach(function (o) {
      var active = state.series.indexOf(o.dataset.value) !== -1;
      o.classList.toggle('is-active', active);
    });
    syncConditionVisibility();
    syncCarcasaVisibility();
  }

  // ── R8 — Marca y Modelo (solo carcasas) ──
  function alternar(lista, valor) {
    var i = lista.indexOf(valor);
    if (i === -1) lista.push(valor); else lista.splice(i, 1);
  }

  document.querySelectorAll('.sf-marca-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      alternar(state.marcas, opt.dataset.value);
      syncSidebarMarcaModelo();
      syncBsMarcaModelo();
      applyFilters();
    });
  });

  document.querySelectorAll('.sf-modelo-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      alternar(state.modelos, opt.dataset.value);
      syncSidebarMarcaModelo();
      syncBsMarcaModelo();
      applyFilters();
    });
  });

  function syncSidebarMarcaModelo() {
    document.querySelectorAll('.sf-marca-option').forEach(function (o) {
      o.classList.toggle('is-active', state.marcas.indexOf(o.dataset.value) !== -1);
    });
    document.querySelectorAll('.sf-modelo-option').forEach(function (o) {
      o.classList.toggle('is-active', state.modelos.indexOf(o.dataset.value) !== -1);
    });
  }

  // Marca y Modelo solo tienen sentido con Carcasas elegido. Al dejar de
  // estarlo se limpian: un filtro activo dentro de un grupo oculto es una
  // trampa — el usuario ve cero resultados y no encuentra por qué.
  function syncCarcasaVisibility() {
    var mostrar = state.series.indexOf('carcasa') !== -1;
    ['marca-filter-group', 'modelo-filter-group',
     'bs-marca-filter-group', 'bs-modelo-filter-group'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = mostrar ? '' : 'none';
    });
    if (!mostrar && (state.marcas.length || state.modelos.length)) {
      state.marcas = [];
      state.modelos = [];
      syncSidebarMarcaModelo();
      syncBsMarcaModelo();
    }
  }

  function syncBsMarcaModelo() {
    document.querySelectorAll('.bs-marca-pill').forEach(function (p) {
      var l = bsTemp.marcas !== undefined ? bsTemp.marcas : state.marcas;
      p.classList.toggle('active', l.indexOf(p.dataset.value) !== -1);
    });
    document.querySelectorAll('.bs-modelo-pill').forEach(function (p) {
      var l = bsTemp.modelos !== undefined ? bsTemp.modelos : state.modelos;
      p.classList.toggle('active', l.indexOf(p.dataset.value) !== -1);
    });
  }

  // ── Condición: oculta/muestra según el tipo seleccionado ──
  // conditionTypes viene de #collection-config (data-condition-types).
  // Vacío en iPhone (siempre visible, sin cambio de comportamiento).
  // En Accesorios: "" o [] = sin filtro de tipo = mostrar (hay AirPods/
  // HomePod entre los productos). Si hay tipos seleccionados, se muestra
  // solo si alguno de ellos maneja condición.
  function syncConditionVisibility() {
    if (!conditionTypes.length) return;
    var showCond = state.series.length === 0 || state.series.some(function (s) {
      return conditionTypes.indexOf(s) !== -1;
    });
    var desktopGroup = document.getElementById('condition-filter-group');
    var bsGroup       = document.getElementById('bs-condition-filter-group');
    if (desktopGroup) desktopGroup.style.display = showCond ? '' : 'none';
    if (bsGroup)       bsGroup.style.display       = showCond ? '' : 'none';

    // Si se oculta, no dejar un filtro de condición invisible
    // descartando resultados en silencio.
    if (!showCond && state.condition !== 'all') {
      state.condition = 'all';
      syncSidebarCondition();
      syncBsCondition();
    }
  }

  // ── SIDEBAR — Precio ──
  document.querySelectorAll('.sf-price-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      state.priceMin = parseInt(opt.dataset.min) || 0;
      state.priceMax = parseInt(opt.dataset.max) || 9999999;
      syncSidebarPrice();
      syncBsPrice();
      applyFilters();
    });
  });

  function syncSidebarPrice() {
    document.querySelectorAll('.sf-price-option').forEach(function (o) {
      var active = parseInt(o.dataset.min) === state.priceMin && parseInt(o.dataset.max) === state.priceMax;
      o.classList.toggle('is-active', active);
    });
  }

  // ── SIDEBAR — Sort ──
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = this.value;
      var mSort = document.getElementById('mobile-sort-select');
      if (mSort) mSort.value = this.value;
      applySort();
    });
  }

  // ── DESKTOP — Limpiar ──
  if (clearBtn) {
    clearBtn.addEventListener('click', clearAllFilters);
  }
  if (nrClearBtn) {
    nrClearBtn.addEventListener('click', clearAllFilters);
  }

  function clearAllFilters() {
    state.condition = 'all';
    state.series    = [];
    state.marcas    = [];
    state.modelos   = [];
    state.priceMin  = 0;
    state.priceMax  = 9999999;
    syncSidebarCondition();
    syncSidebarSerie();
    syncSidebarPrice();
    syncSidebarMarcaModelo();
    syncBsCondition();
    syncBsSerie();
    syncBsPrice();
    syncBsMarcaModelo();
    applyFilters();
  }

  // ── VISTA: Grid / Lista (solo desktop) ──
  var viewGrid = document.getElementById('view-grid');
  var viewList = document.getElementById('view-list');

  if (viewGrid) viewGrid.addEventListener('click', function () {
    state.view = 'grid';
    grid.classList.remove('is-list');
    viewGrid.classList.add('active');
    if (viewList) viewList.classList.remove('active');
  });

  if (viewList) viewList.addEventListener('click', function () {
    state.view = 'list';
    grid.classList.add('is-list');
    viewList.classList.add('active');
    if (viewGrid) viewGrid.classList.remove('active');
  });

  // ── MOBILE SORT ──
  var mobileSortSelect = document.getElementById('mobile-sort-select');
  if (mobileSortSelect) {
    mobileSortSelect.addEventListener('change', function () {
      state.sort = this.value;
      if (sortSelect) sortSelect.value = this.value;
      applySort();
    });
  }

  // ── BOTTOM SHEET ──
  var bsSheet   = document.getElementById('bs-sheet');
  var bsOverlay = document.getElementById('bs-overlay');
  var bsClose   = document.getElementById('bs-close');
  var bsClear   = document.getElementById('bs-clear');
  var bsApply   = document.getElementById('bs-apply');
  var mFilterBtn = document.getElementById('mobile-filter-btn');

  // Estado temporal del bottom sheet
  var bsTemp = {};

  function openBS() {
    // Clonar estado actual al temporal
    bsTemp = {
      condition: state.condition,
      series:    state.series.slice(),
      marcas:    state.marcas.slice(),
      modelos:   state.modelos.slice(),
      priceMin:  state.priceMin,
      priceMax:  state.priceMax,
    };
    syncBsConditionVisibility();
    if (bsSheet)  bsSheet.classList.add('is-open');
    if (bsOverlay) bsOverlay.classList.add('is-open');
    if (bsSheet)  bsSheet.setAttribute('aria-hidden', 'false');
    if (bsSheet)  bsSheet.inert = false;
    document.body.style.overflow = 'hidden';
  }

  function closeBS() {
    if (bsSheet)  bsSheet.classList.remove('is-open');
    if (bsOverlay) bsOverlay.classList.remove('is-open');
    if (bsSheet)  bsSheet.setAttribute('aria-hidden', 'true');
    if (bsSheet)  bsSheet.inert = true;
    document.body.style.overflow = '';
  }

  if (mFilterBtn)  mFilterBtn.addEventListener('click', openBS);
  if (bsClose)    bsClose.addEventListener('click', closeBS);
  if (bsOverlay)  bsOverlay.addEventListener('click', closeBS);

  // Condición en BS
  document.querySelectorAll('.bs-cond-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      bsTemp.condition = pill.dataset.value;
      document.querySelectorAll('.bs-cond-pill').forEach(function (p) {
        p.classList.toggle('active', p.dataset.value === bsTemp.condition);
      });
      updateBsCount();
    });
  });

  // Serie en BS
  document.querySelectorAll('.bs-serie-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var val = pill.dataset.value;
      var idx = bsTemp.series.indexOf(val);
      if (idx === -1) bsTemp.series.push(val);
      else bsTemp.series.splice(idx, 1);
      pill.classList.toggle('active', bsTemp.series.indexOf(val) !== -1);
      syncBsConditionVisibility();
      updateBsCount();
    });
  });

  // Condición dentro del bottom sheet: misma regla que en desktop, pero
  // sobre bsTemp.series (estado provisorio, antes de "Aplicar").
  function syncBsConditionVisibility() {
    if (!conditionTypes.length) return;
    var showCond = bsTemp.series.length === 0 || bsTemp.series.some(function (s) {
      return conditionTypes.indexOf(s) !== -1;
    });
    var bsGroup = document.getElementById('bs-condition-filter-group');
    if (bsGroup) bsGroup.style.display = showCond ? '' : 'none';
    if (!showCond && bsTemp.condition !== 'all') {
      bsTemp.condition = 'all';
      syncBsCondition();
    }
  }

  // Precio en BS
  // R8
  document.querySelectorAll('.bs-marca-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      alternar(bsTemp.marcas, pill.dataset.value);
      syncBsMarcaModelo();
      updateBsCount();
    });
  });

  document.querySelectorAll('.bs-modelo-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      alternar(bsTemp.modelos, pill.dataset.value);
      syncBsMarcaModelo();
      updateBsCount();
    });
  });

  document.querySelectorAll('.bs-price-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      bsTemp.priceMin = parseInt(pill.dataset.min) || 0;
      bsTemp.priceMax = parseInt(pill.dataset.max) || 9999999;
      document.querySelectorAll('.bs-price-pill').forEach(function (p) {
        p.classList.toggle('active',
          parseInt(p.dataset.min) === bsTemp.priceMin &&
          parseInt(p.dataset.max) === bsTemp.priceMax
        );
      });
      updateBsCount();
    });
  });

  function updateBsCount() {
    var cards = getCards();
    var count = cards.filter(function (card) {
      var cond  = card.dataset.condition || '';
      var serie = card.dataset.serie     || '';
      var price = parseInt(card.dataset.price) || 0;
      var condOk  = bsTemp.condition === 'all' || cond === bsTemp.condition;
      var serieOk = bsTemp.series.length === 0 || bsTemp.series.indexOf(serie) !== -1;
      var marcaOk = (bsTemp.marcas || []).length === 0
                    || bsTemp.marcas.indexOf(card.dataset.marca || '') !== -1;
      var modeloOk = (bsTemp.modelos || []).length === 0
                    || bsTemp.modelos.indexOf(card.dataset.modelo || '') !== -1;
      var priceOk = price === 0 || (price >= bsTemp.priceMin && price <= bsTemp.priceMax);
      return condOk && serieOk && priceOk && marcaOk && modeloOk;
    }).length;
    if (bsCount) bsCount.textContent = count;
  }

  // Limpiar BS
  if (bsClear) {
    bsClear.addEventListener('click', function () {
      bsTemp = { condition: 'all', series: [], marcas: [], modelos: [],
                 priceMin: 0, priceMax: 9999999 };
      syncBsCondition();
      syncBsSerie();
      syncBsPrice();
      syncBsConditionVisibility();
      updateBsCount();
    });
  }

  // Aplicar BS
  if (bsApply) {
    bsApply.addEventListener('click', function () {
      state.condition = bsTemp.condition;
      state.series    = bsTemp.series.slice();
      state.marcas    = (bsTemp.marcas || []).slice();
      state.modelos   = (bsTemp.modelos || []).slice();
      state.priceMin  = bsTemp.priceMin;
      state.priceMax  = bsTemp.priceMax;
      syncSidebarCondition();
      syncSidebarSerie();
      syncSidebarPrice();
      syncSidebarMarcaModelo();
      applyFilters();
      closeBS();
    });
  }

  function syncBsCondition() {
    var cond = bsTemp.condition !== undefined ? bsTemp.condition : state.condition;
    document.querySelectorAll('.bs-cond-pill').forEach(function (p) {
      p.classList.toggle('active', p.dataset.value === cond);
    });
  }

  function syncBsSerie() {
    var series = bsTemp.series !== undefined ? bsTemp.series : state.series;
    document.querySelectorAll('.bs-serie-pill').forEach(function (p) {
      p.classList.toggle('active', series.indexOf(p.dataset.value) !== -1);
    });
  }

  function syncBsPrice() {
    var pMin = bsTemp.priceMin !== undefined ? bsTemp.priceMin : state.priceMin;
    var pMax = bsTemp.priceMax !== undefined ? bsTemp.priceMax : state.priceMax;
    document.querySelectorAll('.bs-price-pill').forEach(function (p) {
      p.classList.toggle('active',
        parseInt(p.dataset.min) === pMin && parseInt(p.dataset.max) === pMax
      );
    });
  }

  // ── Inicializar estado desde colección activa o URL param ──
  var config = document.getElementById('collection-config');
  if (config) {
    var activeCond = config.dataset.activeCondition;
    if (activeCond && activeCond !== '') {
      state.condition = activeCond;
      syncSidebarCondition();
      syncBsCondition();
    }
  }

  // Leer ?condicion=/?tipo=/?precio= de la URL (vienen del mega menú)
  var urlParams = new URLSearchParams(window.location.search);
  var urlCond = urlParams.get('condicion');
  if (urlCond && urlCond !== '') {
    state.condition = urlCond;
    syncSidebarCondition();
    syncBsCondition();
  }

  var urlTipo = urlParams.get('tipo');
  if (urlTipo && urlTipo !== '') {
    // R7 — acepta varios tipos separados por coma (?tipo=cable,llavero) para
    // que "Otros accesorios" del megamenú pueda filtrar por su grupo entero.
    state.series = urlTipo.split(',').filter(function (s) { return s !== ''; });
    syncSidebarSerie();
    syncBsSerie();
  }

  // R8 — ?marca=zagg&modelo=modelo-iphone-17-pro, igual que ?tipo=, aceptando
  // lista separada por comas. Se aplican después de ?tipo= para que
  // syncCarcasaVisibility ya haya decidido si los grupos se ven.
  var urlMarca = urlParams.get('marca');
  if (urlMarca) {
    state.marcas = urlMarca.split(',').filter(function (s) { return s !== ''; });
  }
  var urlModelo = urlParams.get('modelo');
  if (urlModelo) {
    state.modelos = urlModelo.split(',').filter(function (s) { return s !== ''; });
  }
  if (urlMarca || urlModelo) {
    syncSidebarMarcaModelo();
  }

  var precioBuckets = {
    'hasta-25000':  { min: 0,     max: 25000 },
    '25000-40000':  { min: 25000, max: 40000 },
    'mas-40000':    { min: 40000, max: 9999999 },
  };
  var urlPrecio = urlParams.get('precio');
  if (urlPrecio && precioBuckets[urlPrecio]) {
    state.priceMin = precioBuckets[urlPrecio].min;
    state.priceMax = precioBuckets[urlPrecio].max;
    syncSidebarPrice();
    syncBsPrice();
  }

  // ── Init ──
  syncSidebarCondition();
  syncSidebarSerie();
  syncSidebarPrice();
  syncSidebarMarcaModelo();
  applySort();

})();